import module from 'nominas/nomina/module.js'
import template from './template.html'

export class NominasNominaDispersionPagosOtrosListaItemComponent {
  data
  onSelect
  onChange

  $onInit () {
    if (this.data.banco) {
      this.descripcion = `Depositar en ${this.data.banco}`
        + (this.data.banco_cuenta ? ` | Cuenta: ${this.data.banco_cuenta}` : '')
        + (this.data.banco_clabe ? ` | CLABE: ${this.data.banco_clabe}` : '')
        + (this.data.banco_tarjeta ? ` | Tarjeta: ${this.data.banco_tarjeta}` : '')
    } else {
      this.descripcion = 'No depositar'
    }
  }

  seleccionar () {
    this.onSelect({$event: {data: this.data}})
  }
}

module.component('nominasNominaDispersionPagosOtrosListaItem', {
  controller: NominasNominaDispersionPagosOtrosListaItemComponent,
  template,
  bindings: {
    data: '<',
    onSelect: '&',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/dispersion/pagos/otros/lista/item/component.js